// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import Calendar from "@guestsupply/XDL/Icons/Calendar";
import CaretLeft from "@guestsupply/XDL/Icons/CaretLeft";
import CaretRight from "@guestsupply/XDL/Icons/CaretRight";
import { xBaseTheme } from "@guestsupply/XDL/types";
import color from "@guestsupply/XDL/Utilities/color";
import DatePickerPresentationPropsDefault from "@insite/mobius/DatePicker/presentationProps";
import getColor from "@insite/mobius/utilities/getColor";
import React from "react";
import { css } from "styled-components";

export default {
    defaultProps: {
        mergeCss: true,
        ...DatePickerPresentationPropsDefault,
        dateTimePickerProps: {
            nextLabel: React.createElement(CaretRight),
            prevLabel: React.createElement(CaretLeft),
        } as any,
        calendarIconProps: {
            ...DatePickerPresentationPropsDefault?.calendarIconProps,
            src: Calendar,
            size: 29,
            color: "primary.main",
            css: css`
                ${DatePickerPresentationPropsDefault?.calendarIconProps?.css}
                padding: 9px;
            `,
        },
        // GSS-353: fixed datepicker icon globally to be on the left, and changed order of clear button to be on the right
        cssOverrides: {
            datePicker: css`
                line-height: 16px;
                .react-calendar {
                    right: unset;
                    left: 0;

                    .react-calendar__navigation {
                        &__arrow {
                            height: auto;
                        }

                        &__prev-button,
                        &__next-button {
                            color: ${getColor("text")};
                            background-image: none;
                            background: transparent;
                            &:enabled {
                                &:focus:not(:disabled) {
                                    background: transparent;
                                }

                                &:hover:not(:disabled) {
                                    background: transparent;
                                    color: ${getColor("common.ui8")};
                                }
                            }

                            &:disabled {
                                opacity: 0.33;
                                cursor: not-allowed;
                            }

                            svg {
                                width: 8px;
                                height: 14px;
                            }
                        }

                        &__label {
                            &:enabled {
                                &:hover:not(:disabled),
                                &:focus:not(:disabled) {
                                    background: transparent;
                                }
                                &:focus:not(:disabled) {
                                    color: ${getColor("text")};
                                    outline: none;
                                }

                                &:hover:not(:disabled) {
                                    color: ${getColor("common.ui8")};
                                }
                            }
                        }
                    }
                }
                .react-datetime-picker {
                    &:not(:disabled) {
                        &:hover {
                            border-color: ${color("common.ui8")};
                        }
                        &:focus-within {
                            border-color: ${color("primary")};
                        }
                    }
                    &:not(:disabled),
                    &:focus-within {
                        padding: 0;
                        min-height: 36px;
                        .react-datetime-picker__inputGroup {
                            order: 2;
                            padding: 0 9px 0 0;
                        }
                        .react-datetime-picker__button {
                            padding-right: 8px;
                            display: flex;
                            align-items: center;
                        }
                        .react-datetime-picker__clear-button {
                            display: none;
                            order: 3;
                        }
                    }
                    &__button {
                        padding-right: 0;
                    }
                }
            `,
        },
    },
} as xBaseTheme["datePicker"];
